export function validateEmail(email: string): boolean {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
}

export function validatePassword(password: string): boolean {
  return password.length >= 8; // Minimum 8 characters
}

export function validateRequiredField(value: string): boolean {
  return value.trim() !== '';
}

export function validatePaymentAmount(amount: number): boolean {
  return amount > 0; // Amount must be greater than zero
}
